export type ScrollbarPositionValue = number | 'start' | 'end';

export class ScrollbarGeometry
{
    public x: number;
    public y: number;

    public w: number;
    public h: number;

    constructor(x: number, y: number, w: number, h: number)
    {
        this.x = x;
        this.y = y;
        this.w = w;
        this.h = h;
    }
}

export class ScrollbarPosition
{
    public x: ScrollbarPositionValue;
    public y: ScrollbarPositionValue;

    constructor(x: ScrollbarPositionValue, y: ScrollbarPositionValue)
    {
        this.x = x;
        this.y = y;
    }
}
